import { Badge } from '../../atoms/Badge';
import Card from '../../atoms/Card';
import Grid from '../../atoms/Grid';
import { StringOrNull } from '../../../types';
import { getJapaneseDateTimeAsString } from '../../../utils/MomentUtil';

import React from 'react';
import { GinieTelephoneRelation } from '../../../external/CustomerInfoAllApi';

export interface GinieTelephonyTableProps {
  data: GinieTelephoneRelation[];
}

const formatSecondToMinute = (secStr: StringOrNull): string => {
  if (!secStr) {
    return '00:00';
  }
  const secInt = parseInt(secStr, 10);

  if (isNaN(secInt)) {
    return '00:00';
  }
  // 分
  const min = Math.floor(secInt / 60);
  // 秒
  const rem = secInt % 60;

  return `${min.toString().length > 2 ? min : ('00' + min).slice(-2)}:${('00' + rem).slice(-2)}`;
};

const GinieTelephonyTable: React.FC<GinieTelephonyTableProps> = ({ data }) => {
  const sortedData = [...data].sort((a, b) => {
    // 降順でsort
    if (a.startDateTime < b.startDateTime) {
      return 1;
    }
    return -1;
  });

  return (
    <>
      {sortedData.map((item) => {
        return (
          <Card className='u-mb24' key={`${item.startDateTime}`}>
            <Card.Content>
              <Grid>
                <Grid.Row>
                  <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
                    <p
                      className='report-cards__item-title'
                      data-testid='g-telephony-start-date-time'
                      data-testid-e2e='g-telephony-start-date-time'>{`発信日時 : ${getJapaneseDateTimeAsString(item.startDateTime)}`}</p>
                  </Grid.Col>
                  <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
                    <p className='report-cards__item-title' data-testid='g-telephony-user-name' data-testid-e2e='g-telephony-user-name'>
                      {`発信者 : ${item.userName}`}
                    </p>
                  </Grid.Col>
                  <Grid.Col colS={12} colM={12} colL={4} className='u-mb8'>
                    <span className='report-cards__item-title' data-testid='g-telephony-call-time' data-testid-e2e='g-telephony-call-time'>
                      {`呼出時間 : ${formatSecondToMinute(item.callTime)}`}
                    </span>
                  </Grid.Col>
                  <Grid.Col colS={12} colM={12} colL={8} className='u-mb8'>
                    <span className='report-cards__item-title' data-testid='g-telephony-talk-time' data-testid-e2e='g-telephony-talk-time'>
                      {`通話時間 : ${formatSecondToMinute(item.talkTime)}`}
                    </span>
                    {formatSecondToMinute(item.talkTime) !== '00:00' ? (
                      <Badge isActive className='u-ml8' backgroundColor='#C0EAC4'>
                        <span data-testid='g-telephony-talk-status' data-testid-e2e='g-telephony-talk-status' style={{ color: 'green' }}>
                          通話
                        </span>
                      </Badge>
                    ) : (
                      <Badge isActive className='u-ml8' backgroundColor='#f2caca'>
                        <span data-testid='g-telephony-talk-status' data-testid-e2e='g-telephony-talk-status' style={{ color: 'red' }}>
                          未接続
                        </span>
                      </Badge>
                    )}
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            </Card.Content>
          </Card>
        );
      })}
    </>
  );
};

export default GinieTelephonyTable;
